<script lang="ts">
  import { fa } from '../shared/i18n/fa';
  import { location } from '../shared/router/router.svelte';
  import { EmptyState } from '../shared/ui';
  import HomeRedirect from './HomeRedirect.svelte';
  import Lazy from './Lazy.svelte';
  import OrgRoute from './OrgRoute.svelte';
  import RequireAuth from './RequireAuth.svelte';
  import RequirePermission from './RequirePermission.svelte';
  import { resolve } from './routes';

  /** The same structure as the React site's router: public pages, then everything behind sign-in. */
  const route = $derived(resolve(location.pathname));
</script>

{#if route.kind === 'public'}
  <Lazy load={route.load} />
{:else if route.kind === 'notFound'}
  <EmptyState>{fa.app.notFound}</EmptyState>
{:else}
  <RequireAuth>
    {#if route.kind === 'auth'}
      {#if route.redirect}
        <HomeRedirect />
      {:else if route.load}
        <Lazy load={route.load} />
      {/if}
    {:else}
      <!-- Everything under an org reads its id once: another org is a fresh tree. -->
      {#key route.orgId}
        <OrgRoute orgId={route.orgId}>
          <RequirePermission permission={route.permission}>
            <Lazy load={route.load} params={route.params} />
          </RequirePermission>
        </OrgRoute>
      {/key}
    {/if}
  </RequireAuth>
{/if}
